export const getClareValleyData = () => ({
  name: "Clare Valley",
  country: "Australie",
  description: "La Clare Valley est une région viticole prestigieuse d'Australie-Méridionale, réputée pour ses Riesling de classe mondiale et ses Shiraz puissants. Son climat continental et ses sols calcaires créent des conditions idéales pour des vins de grande finesse.",
  type: "region",
  mapAreas: [
    { region: "Clare Valley", x: 42, y: 72, color: "#d4a4d4", size: 4 }
  ],
  statistics: {
    totalArea: "4,500 ha",
    production: "0.3 million hectolitres",
    appellations: "Clare Valley GI",
    subregions: "3 sous-régions principales",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat continental avec étés chauds et secs, hivers froids, grandes amplitudes thermiques",
    soil: "Sols calcaires, argileux, excellente rétention d'eau",
    viticulture: "Viticulture traditionnelle, vieilles vignes, rendements limités"
  },
  wineStyles: {
    red: "Shiraz puissants et structurés, Cabernet Sauvignon élégants, assemblages complexes",
    white: "Riesling de classe mondiale, Chardonnay aromatiques, Sauvignon Blanc frais",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture dans la Clare Valley remonte aux années 1840. La région s'est imposée comme l'une des plus prestigieuses d'Australie, reconnue pour ses Riesling de classe mondiale et ses Shiraz de qualité exceptionnelle.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes rouges, fromages affinés, cuisine fusion.",
  subregions: {
    "clare": {
      name: "Clare",
      description: "Cœur de la région, réputé pour ses Riesling de classe mondiale et ses Shiraz puissants.",
      characteristics: {
        climate: "Continental, grandes amplitudes thermiques",
        soil: "Sols calcaires et argileux",
        viticulture: "Vieilles vignes, rendements limités"
      },
      grapeVarieties: {
        white: ["Riesling", "Chardonnay", "Sauvignon Blanc"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "riesling": "Blancs de classe mondiale, vieillissement exceptionnel",
        "shiraz": "Rouges puissants et structurés"
      },
      foodPairing: "Fruits de mer, poissons, fromages affinés"
    },
    "watervale": {
      name: "Watervale",
      description: "Zone de Watervale, connue pour ses Riesling élégants et ses vins rouges structurés.",
      characteristics: {
        climate: "Continental, influence océanique",
        soil: "Sols calcaires et argileux",
        viticulture: "Vignobles historiques, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Riesling", "Chardonnay", "Sauvignon Blanc"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "riesling": "Blancs élégants et aromatiques",
        "rouge": "Rouges structurés et équilibrés"
      },
      foodPairing: "Poissons, volailles, cuisine traditionnelle"
    },
    "auburn": {
      name: "Auburn",
      description: "Zone méridionale, réputée pour ses vins rouges fruités et ses blancs frais.",
      characteristics: {
        climate: "Continental, influence océanique",
        soil: "Sols argileux et calcaires",
        viticulture: "Vignobles modernes, expérimentation variétale"
      },
      grapeVarieties: {
        white: ["Riesling", "Chardonnay", "Sauvignon Blanc"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "rouge": "Rouges fruités et accessibles",
        "blanc": "Blancs frais et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine moderne"
    }
  }
}); 